import str from '@/utils/str';

export default {
    data() {
        return {
            validateErrorHandler: this.validateError
        }
    },
    methods: {
        getValidateError(key) {
            return this.$t("message.validator." + key);
        },
        showValidateError(key) {
            this.validateErrorHandler(this.getValidateError(key));
            return false;
        },
        validateError(message) {
            this.$message.error(message);
        },
        validatePassword(password, key = 'password') {
            // 密碼為空
            if (!password || !str.trim(password)) {
                return this.showValidateError(key + '.required');
            }

            //密碼長度不正確
            if (password.length < 6 || password.length > 15) {
                return this.showValidateError(key + '.length');
            }

            // 密碼必須包含英數字且不能有特殊符號
            let pattern = /^(?=\D*\d)(?=[^a-zA-Z]*[a-zA-Z])[0-9a-zA-Z]+$/i;

            if (pattern.test(password) == false) {
                return this.showValidateError(key + '.regex');
            }

            return true;
        },
        validatePasswordChange(password, repassword, key = 'password') {

            if (!this.validatePassword(password, key)) {
                return false;
            } else {
                if (password !== repassword) {
                    return this.showValidateError('repassword');
                }
            }

            return true;
        },
        validateUsername(username, regex)
        {
            let r = new RegExp(regex);

            if (false == r.test(username)) {
                return this.showValidateError('username_pattern');
            }

            return true;
        }
    }
}